var _rect, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStoreBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 50,
    viewBox: "0 0 162 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 50,
    rx: 8,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12, 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 6L8 14L14 10L8 6Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10L25 16L25 4L14 10Z",
    fill: "#FFFFFF",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14L14 10L25 16L8 16V14Z",
    fill: "#FFFFFF",
    fillOpacity: 0.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 20,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "#FFFFFF",
    letterSpacing: "0.5px"
  }, "GET IT ON")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 35,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#FFFFFF",
    letterSpacing: "0.5px"
  }, "Google Play")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreBadge);
export default __webpack_public_path__ + "static/media/play-store-badge.878889396c1cccae2002ba0f5e503174.svg";
export { ForwardRef as ReactComponent };